// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ltcs","file":"styles_file__2ZV_Z"};